import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() {}

  // Method to store an object in local storage
  setItemInSession(key: string, value: any): void {
    try {
      const serializedValue = JSON.stringify(value);
      sessionStorage.setItem(key, serializedValue);
    } catch (error) {
      console.error('Error storing item in local storage:', error);
    }
  }


  // Generic method to retrieve an item from local storage
  getItemFromSession<T>(key: string, removeAfterRetrieval: boolean = false): T | null {
    try {
      const serializedValue = sessionStorage.getItem(key);
      if (serializedValue === null) {
        return null;
      }
      const item= JSON.parse(serializedValue) as T;
      if (removeAfterRetrieval) {
        sessionStorage.removeItem(key);
      }
      return item;
    } catch (error) {
      console.error('Error retrieving item from local storage:', error);
      return null;
    }
  }

  removeFromSession(key: string): void {
    sessionStorage.removeItem(key);
  }
}
